// Strips model "scaffolding" that occasionally leaks into the answer text and would otherwise
// render as literal junk above the response. Applied to every assistant message before extraction
// and rendering, so it benefits both chat and scheduled conversations.
//
// Handles two observed leaks (seen with Gemini + the analyst system prompt):
//   1. <thought>…</thought> reasoning blocks (the frontend has no concept of these — they are not
//      artifacts like <csv>/<geojson>/<outimg>, so without this they show verbatim).
//   2. A leading "Do not mention tool names or their output." directive the model sometimes echoes.
export function stripModelScaffolding(text: string): string {
  if (!text) return text;
  return text
    // Matched reasoning blocks (the common case): drop them entirely.
    .replace(/<thought>[\s\S]*?<\/thought>/gi, '')
    // Orphan/unclosed thought tags: remove just the tag so no literal "<thought>" survives.
    .replace(/<\/?thought>/gi, '')
    // Leading echoed directive (only at the very start, after any whitespace).
    .replace(/^\s*Do not mention tool names or their output\.?\s*/i, '')
    .trim();
}
